import React from 'react';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import usersActions from '../../../../../actions/users.actions';
import NewUserPage from './NewUserPage';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import helper from '../../../../../utils/helper';
import lookupActions from '../../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';

class NewUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      roles: [],
      groups: [],
      isSubmitting: false,
      loading: false,
      errors: '',
      settings: null,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.lookup.roles !== prevState.roles) {
      state.roles = nextProps.lookup.roles;
    }
    if (nextProps.lookup.groups !== prevState.groups) {
      state.groups = nextProps.lookup.groups;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    await this.props.lookupActions.getDepartmentsWithoutGlobal();
    await this.props.lookupActions.getRoles();
    await this.props.lookupActions.getGroups();
  }
  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.state.departments, prevState.departments)) {
      const { deptId } = helper.getUserDepartment(this.state.departments);
      usersActions
        .getDeptSettings(deptId)
        .then((settings) => this.setState({ settings }));
    }
  }
  onChangeDept = (deptId) => {
    usersActions
      .getDeptSettings(deptId)
      .then((settings) => this.setState({ settings }));
  };

  onCreateUser = (params) => {
    const _params = Object.assign({}, params);
    _params.roleNames = [params.roleNames];
    this.props.configureActions
      .createUser(_params)
      .then(() => this.props.history.push('/configure/users'))
      .catch((err) => console.log(err));
  };

  render() {
    const { loading, departments } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    const { deptName, deptId } = helper.getUserDepartment(departments);
    return (
      <NewUserPage
        {...this.state}
        onCreateUser={this.onCreateUser}
        initDeptId={deptId}
        initDeptName={deptName}
        onChangeDept={this.onChangeDept}
        settings={this.state.settings}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(NewUser);
